
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.334 6.878c0-3.066 2.563-5.545 5.662-5.545 3.109 0 5.671 2.479 5.671 5.545 0 1.545-.562 2.98-1.487 4.196a14.708 14.708 0 01-3.694 3.427c-.324.212-.616.228-.972 0a14.427 14.427 0 01-3.693-3.427c-.926-1.216-1.487-2.65-1.487-4.196zm3.796.173c0 1.027.838 1.835 1.866 1.835 1.029 0 1.875-.808 1.875-1.835 0-1.02-.846-1.867-1.875-1.867A1.876 1.876 0 006.13 7.051z","fill":"#202A21"}})])
          )
        }
      }
    